import { getMessage } from '@gef-ui/localization/messages';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import GcpProgress from '../GcpProgress';
const AppLoader = ({ skipDelay = false })=>{
    const [isInitDelay, setIsInitDelay] = useState(!skipDelay);
    useEffect(()=>{
        if (!skipDelay) {
            // this is because of loading config.json
            // if config.json is loaded under 200ms then we don't need bother user with ugly loader
            const initDelayTimeout = setTimeout(()=>{
                setIsInitDelay(false);
            }, 200);
            return ()=>{
                clearTimeout(initDelayTimeout);
            };
        }
    }, [
        skipDelay
    ]);
    if (isInitDelay) {
        return /*#__PURE__*/ React.createElement("div", null);
    }
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '100vh'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        spacing: 3,
        direction: "column",
        sx: {
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(GcpProgress, null), /*#__PURE__*/ React.createElement(Typography, {
        align: "center"
    }, getMessage('common:loadingApplication'))));
};
AppLoader.propTypes = {
    skipDelay: PropTypes.bool
};
export default AppLoader;
